import { render } from "./salary.vue?vue&type=template&id=824dad38&scoped=true"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"

import "./salary.vue?vue&type=style&index=0&id=824dad38&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824dad38"]])

export default __exports__